module.exports = __webpack_public_path__ + "img/antes_despues_77.d6fa9601.png";